const ArchitectureSVG: React.FC = () => (
  <svg
    viewBox="0 0 400 300"
    className="w-full h-full transform transition-transform duration-300 rounded-lg"
  >
    <defs>
      <linearGradient id="arch-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#2a9d8f" stopOpacity="0.1" />
        <stop offset="100%" stopColor="#5b79aa" stopOpacity="0.05" />
      </linearGradient>
      <filter id="arch-glow">
        <feGaussianBlur stdDeviation="1.5" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    <path
      d="M0 0h400v300H0z"
      fill="url(#arch-gradient)"
      className="transition-opacity duration-300"
    />

    {/* Blueprint Grid */}
    <g stroke="#2a9d8f" strokeWidth="0.5" opacity="0.1">
      {[...Array(20)].map((_, i) => (
        <line key={`v${i}`} x1={i * 20} y1="0" x2={i * 20} y2="300" />
      ))}
      {[...Array(15)].map((_, i) => (
        <line key={`h${i}`} x1="0" y1={i * 20} x2="400" y2={i * 20} />
      ))}
    </g>

    <g
      className="transform transition-transform duration-500 hover:translate-y-1"
      filter="url(#arch-glow)"
    >
      {/* Architectural Framework with floating layers */}
      {[0, 1, 2, 3].map((i) => (
        <g
          key={i}
          style={{
            animation: `float ${3 + i}s ease-in-out infinite ${i * 0.3}s`,
            transformOrigin: "center",
          }}
        >
          {/* Layer Base with pulse */}
          <rect
            x={100}
            y={80 + i * 40}
            width={200}
            height={30}
            rx={6}
            fill="#2a9d8f"
            opacity={0.1 + i * 0.05}
            style={{
              animation: `pulse-opacity ${2 + i}s ease-in-out infinite ${
                i * 0.2
              }s`,
            }}
          />

          {/* Layer Highlight with scale */}
          <rect
            x={105}
            y={85 + i * 40}
            width={190}
            height={20}
            rx={4}
            fill="#5b79aa"
            opacity={0.05 + i * 0.03}
            style={{
              animation: `scale ${3 + i}s ease-in-out infinite ${i * 0.4}s`,
              transformOrigin: "center",
            }}
          />

          {/* Connection Points with pulse */}
          {[0, 1, 2].map((j) => (
            <circle
              key={j}
              cx={130 + j * 70}
              cy={95 + i * 40}
              r={3}
              fill="#2a9d8f"
              opacity="0.4"
              style={{
                animation: `pulse-opacity ${2 + j}s ease-in-out infinite ${
                  j * 0.3
                }s`,
              }}
            />
          ))}
        </g>
      ))}

      {/* Connecting Lines with flow */}
      <g opacity="0.3">
        {[1, 2, 3].map((i) => (
          <g key={i}>
            {[130, 200, 270].map((x, j) => (
              <path
                key={j}
                d={`M${x} ${110 + (i - 1) * 40} L${x} ${120 + (i - 1) * 40}`}
                stroke="#5b79aa"
                strokeWidth="1.5"
                strokeDasharray="3,3"
                style={{
                  animation: `flow ${2 + i + j}s linear infinite ${
                    (i + j) * 0.2
                  }s`,
                }}
              />
            ))}
          </g>
        ))}
      </g>

      {/* Decorative Elements with orbit */}
      <g>
        {[0, 60, 120, 180].map((angle, i) => (
          <g
            key={i}
            style={{
              animation: `orbit ${15 + i * 2}s linear infinite`,
              transformOrigin: "200px 150px",
            }}
          >
            <circle
              cx={200 + Math.cos((angle * Math.PI) / 180) * 120}
              cy={150 + Math.sin((angle * Math.PI) / 180) * 120}
              r={4}
              fill="#2a9d8f"
              opacity="0.4"
              style={{
                animation: `pulse-opacity ${2 + i}s ease-in-out infinite ${
                  i * 0.2
                }s`,
              }}
            />
          </g>
        ))}
      </g>

      {/* Additional Floating Particles */}
      {[0, 45, 90, 135].map((angle, i) => (
        <circle
          key={i}
          cx={200 + Math.cos((angle * Math.PI) / 180) * 100}
          cy={150 + Math.sin((angle * Math.PI) / 180) * 100}
          r={2}
          fill="#5b79aa"
          opacity="0.6"
          style={{
            animation: `float ${3 + i}s ease-in-out infinite ${
              i * 0.2
            }s, pulse-opacity ${2 + i}s ease-in-out infinite ${i * 0.3}s`,
          }}
        />
      ))}
    </g>
  </svg>
);

export default ArchitectureSVG;
